import React from "react";
import styled from "styled-components";

import AccountIcon from "../Icons/AccountIcon";
import AccountCircleIcon from "../Icons/AccountCircleIcon";

export type AccountLinkProps = {
  href: string;
  label: string;
  hideLabel?: boolean;
  isOnDarkBackground?: boolean;
};

const StyledLink = styled.a`
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;

  > svg {
    display: inline-block;
    vertical-align: middle;
  }
`;

const StyledLabel = styled.span<{ isOnDarkBackground?: boolean }>`
  display: inline-block;
  vertical-align: middle;
  margin-left: ${(props) => props.theme.spacings.small};
  color: ${(props) =>
    props.isOnDarkBackground
      ? props.theme.palette.white
      : props.theme.palette.brand.main};
  &:hover {
    color: ${(props) =>
      props.isOnDarkBackground
        ? props.theme.palette.gray[200]
        : props.theme.palette.brand[300]};
  }
`;

const AccountLink: React.FC<React.PropsWithChildren<AccountLinkProps>> = ({
  hideLabel,
  href,
  label,
  isOnDarkBackground,
}) => (
  <StyledLink aria-label={label} href={href}>
    {hideLabel ? (
      <AccountCircleIcon
        isOnDarkBackground={isOnDarkBackground}
        color="brand"
        scale="gigantic"
      />
    ) : (
      <AccountIcon
        color="brand"
        scale="tiny"
        isOnDarkBackground={isOnDarkBackground}
      />
    )}
    {!hideLabel ? (
      <StyledLabel isOnDarkBackground={isOnDarkBackground}>{label}</StyledLabel>
    ) : null}
  </StyledLink>
);

export default AccountLink;
